export default {
    payments: {
        webOnly: {
            title: 'Manage your subscription on the web',
            message:
                'Subscription purchases and payment management are not available in this app. ' +
                'You can manage your subscription from your account on the Chill Anywhere website ' +
                'using a desktop or mobile web browser.'
        },
        payment: {
            title: 'Payment Information',
            message:
                'We’re happy you’ve decided to continue living a less stressed, more mindful life with us.',
            subtitle: 'Payment Details',
            subtitleCoupon: 'Coupon Code',
            footerText:
                'Secure credit card payments' +
                '</br>' +
                'This is a secure 128-bit SSL encrypted payment',
            deleteButton: 'Delete Card'
        },
        successMessages: {
            subscriptionCreated: 'Subscription successful',
            subscriptionUpdated: 'Subscription updated',
            subscriptionCanceled: 'Subscription canceled',
            cardUpdated: 'Card updated',
            cardDeleted: 'Card deleted'
        },
        packages: {
            title: 'Let`s get started',
            message:
                'Studies show that daily mindfulness practices help with loads of good stuff including lowering stress, anxiety and blood pressure + improving attitudes and sleep. \n' +
                '</br>' +
                '</br>' +
                'Want to make chilling-out a regular habit? Choose a subscription option that best suits your life.',
            corporate: {
                title: 'Corporate Members',
                description:
                    'to log in if your organization has provided you access',
                linkText: 'Click here '
            },
            packages: [
                {
                    title: 'Annual',
                    type: 'plan_130_annual',
                    period: 'year',
                    price: '129',
                    description: '$10.75 / month',
                    trialDays: '14',
                    image:
                        'https://s3.us-east-2.amazonaws.com/chillanywhere.com/assests/packages/clouds-min.png'
                },
                {
                    title: 'Monthly',
                    type: 'plan_20_monthly',
                    period: 'month',
                    price: '19.99',
                    description: '',
                    trialDays: '7',
                    image:
                        'https://s3.us-east-2.amazonaws.com/chillanywhere.com/assests/packages/water-min.png'
                }
            ],
            packagesNoTrial: [
                {
                    title: 'Annual',
                    type: 'price_1GuZgAA0gutf6HOIxHdReTmm',
                    period: 'year',
                    price: '129',
                    description: '$10.75 / month',
                    trialDays: '14',
                    image:
                        'https://s3.us-east-2.amazonaws.com/chillanywhere.com/assests/packages/clouds-min.png'
                },
                {
                    title: 'Monthly',
                    type: 'price_1GuZgUA0gutf6HOICTkJDDAe',
                    period: 'month',
                    price: '19.99',
                    description: '',
                    trialDays: '7',
                    image:
                        'https://s3.us-east-2.amazonaws.com/chillanywhere.com/assests/packages/water-min.png'
                }
            ]
        },
        packagesPublic: {
            title: 'Let`s get started',
            message:
                'Studies show that daily mindfulness practices help with loads of good stuff including lowering stress, anxiety and blood pressure + improving attitudes and sleep. \n' +
                '</br>' +
                '</br>' +
                'Want to make chilling-out a regular habit? Choose a subscription option that best suits your life.',
            hint:
                'To redeem a gift or PROMO code, please select an annual or monthly subscription. You will be prompted to enter your code on the billing screen.',
            packages: [
                {
                    title: 'Try it for 14 days',
                    type: 'free',
                    period: '',
                    price: 'Free',
                    description: '',
                    tabIndex: '1',
                    image:
                        'https://s3.us-east-2.amazonaws.com/chillanywhere.com/assests/packages/free-min.png'
                },
                {
                    title: 'Annual',
                    type: 'plan_130_annual',
                    period: 'year',
                    price: '129',
                    description: '$10.75 / month',
                    tabIndex: '2',
                    image:
                        'https://s3.us-east-2.amazonaws.com/chillanywhere.com/assests/packages/clouds-min.png'
                },
                {
                    title: 'Monthly',
                    type: 'plan_20_monthly',
                    period: 'month',
                    price: '19.99',
                    description: '',
                    tabIndex: '3',
                    image:
                        'https://s3.us-east-2.amazonaws.com/chillanywhere.com/assests/packages/water-min.png'
                }
            ],
            packagesNoTrial: [
                {
                    title: 'Try it for 14 days',
                    type: 'free',
                    period: '',
                    price: 'Free',
                    description: '',
                    tabIndex: '1',
                    image:
                        'https://s3.us-east-2.amazonaws.com/chillanywhere.com/assests/packages/free-min.png'
                },
                {
                    title: 'Annual',
                    type: 'price_1GuZgAA0gutf6HOIxHdReTmm',
                    period: 'year',
                    price: '129',
                    description: '$10.75 / month',
                    tabIndex: '2',
                    image:
                        'https://s3.us-east-2.amazonaws.com/chillanywhere.com/assests/packages/clouds-min.png'
                },
                {
                    title: 'Monthly',
                    type: 'price_1GuZgUA0gutf6HOICTkJDDAe',
                    period: 'month',
                    price: '19.99',
                    description: '',
                    tabIndex: '3',
                    image:
                        'https://s3.us-east-2.amazonaws.com/chillanywhere.com/assests/packages/water-min.png'
                }
            ],
            packageCorporate: {
                title: 'Corporate Members',
                type: 'corporate',
                period: '',
                price: '',
                description:
                    'Click here to log in if your organization has provided you access',
                tabIndex: '4',
                image:
                    'https://s3.us-east-2.amazonaws.com/chillanywhere.com/assests/packages/corporate-min.png'
            }
        }
    }
};
